import axios from 'axios';

// Create axios instance
const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: 600000,
});

// Request interceptor to add authorization header
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('access_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If we get a 401, remove the token and redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      
      // Only redirect if we're in the browser and redirect is not explicitly skipped
      const cfg: unknown = error.config;
      const headers: unknown = error.config && typeof error.config === 'object'
        ? (error.config as Record<string, unknown>).headers
        : undefined;
      const skipAuthRedirect = Boolean(
        (cfg && typeof cfg === 'object' && (cfg as Record<string, unknown>)['skipAuthRedirect']) ||
        (headers && typeof headers === 'object' && (headers as Record<string, unknown>)['X-Skip-Auth-Redirect'])
      );
      if (typeof window !== 'undefined' && !skipAuthRedirect) {
        window.location.href = '/auth/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
